import React from "react";
import { Spin, Tabs } from "antd";
import { PushpinOutlined } from "src/icons";

import OverviewCard from "./OverviewCard";
import styles from "./index.module.scss";
import { devLogging } from "src/utils/logger";
import { safeGet } from "src/shared/utils";
import { ISinglePin } from "src/shared/types";
import { RunningAnobisMode } from "src/shared/config";

interface IPinnedContainerProps {
  selectedTab: any;
  isPulledUp: boolean;

  showDetails(id: any, name: string): void;

  isPending: boolean;

  onChangeTab(any): void;

  pins: {
    errors: any;
    failure: boolean;
    payload: {
      hasMore: boolean;
      pageNo: number;
      pageSize: number;
      data: ISinglePin[];
    };
    pending: boolean;
    success: boolean;
  };

  switchToManageMetrics(val: boolean): void;
  brokenPodsVisibleTabs?: string[];
}

const PinnedContainer = (props: IPinnedContainerProps) => {
  const { showDetails, pins, onChangeTab, brokenPodsVisibleTabs } = props;

  const handleTabChange = (key: string) => {
    onChangeTab({ label: key });
  };

  // get the tab name from the tab key to display on screen
  const makeTabNames = (tabName: string) => {
    if (tabName.includes("_imcom")) {
      tabName = tabName.split("_imcom")[0];
    }
    return tabName
      .replace(/([a-z])([A-Z])/g, "$1 $2") // split camelCase to words
      .replace(/\bHr\b/g, "Hour") // replace "Hr" with "Hour"
      .replace(/\bCurr\b/g, "Current"); // replace "Curr" with "Current"
  };

  return (
    <main className={styles["pinned-container"]}>
      {devLogging("get payload data", safeGet(pins, "payload.data", []), props.selectedTab)}
      {safeGet(pins, "payload.data", []).length ? (
        <Tabs activeKey={props.selectedTab} onChange={handleTabChange}>
          {/*type="card" tabBarGutter={1}>*/}
          {RunningAnobisMode.SHOW_IM_COM_TIME_TAB.map((tabName) => (
            <Tabs.TabPane tab={makeTabNames(tabName)} key={tabName}>
              {[...safeGet(pins, "payload.data", [])].map((cardItem) => (
                <OverviewCard
                  data={cardItem}
                  key={cardItem.id}
                  id={cardItem.id}
                  showDetails={showDetails}
                  failure={safeGet(pins, "failure", false)}
                  pending={safeGet(pins, "pending", false)}
                  selectedTab={props.selectedTab}
                  brokenPodsVisibleTabs={brokenPodsVisibleTabs}
                />
              ))}
            </Tabs.TabPane>
          ))}
        </Tabs>
      ) : (
        <>
          {safeGet(pins, "success", false) && (
            <div className={styles["no-pin-imcom"]}>
              <p>Reach Out to #anobis-support slack channel.</p>
            </div>
          )}
          {safeGet(pins, "pending", false) && (
            <div className={styles["spinner"]}>
              <Spin />
            </div>
          )}
          {safeGet(pins, "failure", false) && <div className={styles["no-pin"]}>Couldn't fetch data !</div>}
        </>
      )}
      {safeGet(pins, "pending", false) && safeGet(pins, "payload.data", []).length > 0 && (
        <div className={styles["spinner"]}>
          <Spin />
        </div>
      )}
    </main>
  );
};

export default PinnedContainer;
